import React from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Link,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import AmlActions from "../components/AmlActions";
import { StatusNaming } from "../constant/amlConstant";
import { fullName } from "../utils/investor";
import { format, parse } from "date-fns";
import { getAdviserLink } from "../utils/adviserLinks";
import { InvestorAmlOverview } from "../api/transformers/aml";

interface ReviewTableProps {
  loading?: boolean;
  dataSource: InvestorAmlOverview[];
  onRowAction: (row: InvestorAmlOverview, key: string) => void;
}

const ReviewTable: React.FC<ReviewTableProps> = ({ dataSource, loading, onRowAction }) => {

  const renderRow = (row: InvestorAmlOverview, index: number) => {
    return (
      <TableRow key={`${row.personId}-${index}`}>
        <TableCell sx={{ display: "grid" }}>
          <Typography>{fullName(row)}</Typography>
          <Typography sx={{ fontWeight: 600, fontStyle: "italic" }}>{row.customerName}</Typography>
          <Link
            href={getAdviserLink("investorDetail", { personId: row.personId })}
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            {row.personId}
          </Link>
        </TableCell>
        <TableCell>
          <Link
            href={getAdviserLink("accountDetail", {
              personId: row.personId,
              accountId: row.onboardingAccountId,
            })}
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            {row.onboardingAccountId}
          </Link>
        </TableCell>
        <TableCell>
          {format(
            parse(row.onboardingDate, "yyyyMMdd", new Date()),
            "dd/MM/yyyy"
          )}
        </TableCell>
        <TableCell>{StatusNaming[row.amlStatus]}</TableCell>
        <TableCell>{row.idvDescription || "-"}</TableCell>
        <TableCell>{row.pepDescription || "-"}</TableCell>
        <TableCell>{row.sanctionsDescription || "-"}</TableCell>
        <TableCell>{row.riskRatingDescription || "-"}</TableCell>
        <TableCell>{row.assignee || "Unassigned"}</TableCell>
        <TableCell>
          <AmlActions personId={row.personId} onActionClick={(key) => onRowAction(row, key)}/>
        </TableCell>
      </TableRow>
    );
  };

  return (
    <TableContainer
      component={Paper}
      sx={{ p: 0, width: "100%", maxHeight: 500 }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Investor or Contact</TableCell>
            <TableCell>Onboarding Account</TableCell>
            <TableCell>Onboarding Date</TableCell>
            <TableCell>AML Status</TableCell>
            <TableCell>ID&V</TableCell>
            <TableCell>PEP</TableCell>
            <TableCell>Sanctions</TableCell>
            <TableCell>Risk Rating</TableCell>
            <TableCell>Assignee</TableCell>
            <TableCell>-</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={10}>
                <Box
                  sx={{
                    minHeight: 300,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              </TableCell>
            </TableRow>
          ) : (
            dataSource.map((row, index) => renderRow(row, index))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReviewTable;
